import Cookies from 'js-cookie'

const TokenKey = 'loginToken'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  // return Cookies.set(TokenKey, token)

  return Cookies.set(TokenKey, token, {
    expires: 7,
    sameSite: 'Lax'   // 默认即可，防止部分浏览器警告
  })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js